import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatState} from 'api/types'

export const historyResults: CaseReducer<NinchatState> = (state) => state
